import type { RegisterParams } from '@common/workflow/serviceActivityRegistry';
import { CustomControlCode } from '@common/enums';
import { holterGradingSections } from '@common/validation/customControls/cardiology/holter/holterGradingSchemas';
import { ServiceActivityRegistry } from '@common/workflow/serviceActivityRegistry';
import { holterAnalysisReportSections } from './holterAnalysisReportSchemas';
import { holterConfigureSections } from './holterConfigureSchemas';
import { holterConsultRequestSections } from './holterConsultRequestSchemas';
import { holterConsultSections } from './holterConsultSchemas';
import { holterDiaryUploadSections } from './holterDiaryUploadSchemas';
import { holterDirectExaminationRequestSections } from './holterDirectExaminationRequestSchemas';
import { holterExternalExaminationRequestSections } from './holterExternalExaminationRequestSchemas';
import { holterFollowUpConsultRequestSections } from './holterFollowUpConsultRequestSchemas';
import { holterHomeExaminationRequestSections } from './holterHomeExaminationRequestSchemas';
import {
    cardioHolterReadOutSections,
    holterReadOutDraftSchema,
    holterReadOutFinalSchema,
} from './holterReadOutSchemas';
import { holterSecondRoundAnswerSections } from './holterSecondRoundAnswerSchemas';
import { HolterSecondRoundQuestionSections } from './holterSecondRoundQuestionSchemas';
import { holterZorgdomeinExaminationRequestSections } from './holterZorgdomeinExaminationRequestSchemas';

const registryElements: RegisterParams[] = [
    {
        customControlCode: CustomControlCode.HolterDirectExaminationRequest,
        sections: holterDirectExaminationRequestSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HolterExternalExaminationRequest,
        sections: holterExternalExaminationRequestSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HolterHomeExaminationRequest,
        sections: holterHomeExaminationRequestSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HolterZorgdomeinExaminationRequest,
        sections: holterZorgdomeinExaminationRequestSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HolterConfigure,
        sections: holterConfigureSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HolterReadOut,
        draft: holterReadOutDraftSchema,
        final: holterReadOutFinalSchema,
        readSections: cardioHolterReadOutSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HolterDiaryUpload,
        sections: holterDiaryUploadSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HolterAnalysisReport,
        sections: holterAnalysisReportSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HolterGrading,
        sections: holterGradingSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HolterConsultRequest,
        sections: holterConsultRequestSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HolterConsult,
        sections: holterConsultSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HolterFollowUpConsultRequest,
        sections: holterFollowUpConsultRequestSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HolterSecondRoundQuestion,
        sections: HolterSecondRoundQuestionSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HolterSecondRoundAnswer,
        sections: holterSecondRoundAnswerSections,
        version: 1,
    },
];

ServiceActivityRegistry.instance.registerAll(registryElements);
